module.exports = __webpack_public_path__ + "static/media/Website.bc4b885c.svg";